import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { eventBus } from "../EventBus";
import { openChatIdAtom } from "../State/openChatId";
import { toast } from "sonner";

interface PushMessage {
  type: "PUSH_NEW_MESSAGE" | "NAVIGATE_TO_CHAT" | "NAVIGATE_TO_URL";
  chatId?: string;
  messageId?: string;
  preview?: string;
  url?: string;
}

export const usePushMessageListener = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const widgetOpenChatId = useRecoilValue(openChatIdAtom);

  useEffect(() => {
    const channel = new BroadcastChannel("push-messages");

    const handleMessage = (event: MessageEvent<PushMessage>) => {
      const { data } = event;

      if (data.type === "PUSH_NEW_MESSAGE" && data.chatId) {
        const currentChatId = extractChatIdFromPath(location.pathname);
        const chatIsAlreadyOpen = currentChatId === data.chatId || widgetOpenChatId === data.chatId;

        eventBus.emit("PUSH_NEW_MESSAGE", {
          chatId: data.chatId,
          messageId: data.messageId,
          preview: data.preview,
        });

        if (!chatIsAlreadyOpen) {
          toast.info("Mike ha respondido a tu consulta", {
            action: {
              label: "Ver",
              onClick: () => navigate(`/chat/${data.chatId}`),
            },
          });
        }
      }

      if (data.type === "NAVIGATE_TO_CHAT" && data.chatId) {
        navigate(`/chat/${data.chatId}`);
      }

      if (data.type === "NAVIGATE_TO_URL" && data.url) {
        navigate(data.url);
      }
    };

    channel.addEventListener("message", handleMessage);

    return () => {
      channel.removeEventListener("message", handleMessage);
      channel.close();
    };
  }, [navigate, location.pathname, widgetOpenChatId]);
};

function extractChatIdFromPath(pathname: string): string | null {
  const match = pathname.match(/^\/chat\/(.+)$/);
  return match ? match[1] : null;
}
